<template>
    <v-flex xs12 class="businesses_banner">
        <v-layout row wrap>
            <v-flex sm8>
                <Breadcrumb></Breadcrumb>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import Breadcrumb from "../Layout/Breadcrumb";

    export default {
        name: 'BusinessesBanner',
        components: {
            Breadcrumb,
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .businesses_banner {
        background: url(../../assets/ypo-banner.jpg);
        position: relative;
        min-height: 150px;
        background-size: cover;
        background-position: center;
        margin-top: 64px;

        &:before {
            content: '';
            background: rgba($ypo_blue, 0.5);
            position: absolute;
            width: 100%;
            height: 100%;
        }
    }
</style>        
